let vars = {};

vars.html = document.querySelector('html');
vars.isMobile = () => innerWidth <= 767;
vars.isTablet = () => innerWidth >= 768 && innerWidth <= 1024;
vars.isDesktop = () => innerWidth >= 1025;
vars.winWidth = window.innerWidth;

vars.regex = {
	name: /^([a-zA-Zа-яА-Я ]){1,500}$/,
	email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export default vars;
